import clsx from 'clsx';
import type { FC } from 'react';

import useLocalStorage from '@/lib/hooks/useLocalStorage.ts';

type BackwallVideoProps = {
  src: string;
  alt: string;
  className?: string;
};

const BackwallVideo: FC<BackwallVideoProps> = ({ src, alt, className }) => {
  const [volume, setVolume] = useLocalStorage('DEALER_VIDEO_VOLUME', 0.5);

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      src={src}
      aria-label={alt}
      className={clsx('img-fluid', className)}
      controls
      onLoadStart={(e) => {
        e.currentTarget.volume = volume;
      }}
      onVolumeChange={(e) => {
        setVolume(e.currentTarget.volume);
      }}
      onError={(e) => {
        e.currentTarget.style.display = 'none';
      }}
    />
  );
};

export default BackwallVideo;
